var map = {
	"./en": 5328,
	"./en/": 5328,
	"./en/cheatsheets": 563,
	"./en/cheatsheets.ts": 563,
	"./en/community": 1845,
	"./en/community.ts": 1845,
	"./en/documentation": 6574,
	"./en/documentation.ts": 6574,
	"./en/dt": 3866,
	"./en/dt.ts": 3866,
	"./en/en": 8796,
	"./en/en.ts": 8796,
	"./en/footer": 4105,
	"./en/footer.ts": 4105,
	"./en/handbook": 7846,
	"./en/handbook.ts": 7846,
	"./en/head-seo": 3468,
	"./en/head-seo.ts": 3468,
	"./en/index": 5328,
	"./en/index.ts": 5328,
	"./en/index2": 5864,
	"./en/index2.ts": 5864,
	"./en/nav": 6461,
	"./en/nav.ts": 6461,
	"./en/playground": 2531,
	"./en/playground.ts": 2531,
	"./en/tsconfig": 8381,
	"./en/tsconfig.ts": 8381,
	"./inYourLanguage": 7586,
	"./inYourLanguage.ts": 7586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3606;